export default __webpack_public_path__ + "static/qt-sweetcombe-marque-3-star-orange-rgb-18830ca1119f1b07d843fd02d4581e1e.png";